Postlogin = ((my) => {
    my.LessonsInterestByUsersReport = {};
    const me = my.LessonsInterestByUsersReport;

    me.$reportResultsTable = $('#report-results-table');
    me.reportSelectOption = $('#report-select').find('option[value="LessonsInterestByUsersReport"]');
    me.reportUrl = me.reportSelectOption.data('report-url');
    me.exportUrl = me.reportSelectOption.data('report-export-url');
    me.assignmentUrl = me.reportSelectOption.data('assignment-url');

    me.filters = ['user-license-ids', 'search-date', 'lessons', 'subtitle', 'user-grades'];

    me.setup = () => {
        $('.filter-column').each((index, element) => {
            const thisFilter = $(element);
            if (me.filters.includes(thisFilter.data('filter-name'))) {
                thisFilter.removeClass('hide');
            } else {
                thisFilter.addClass('hide');
            }
        });

        $('.search-date').find('.help-block').text('Limits the results for the assignment dates.');
        me.initEvents();

        me.$reportResultsTable.bootstrapTable('destroy');
        $('#report-toolbar').hide();
    };

    me.runReport = () => {
        me.$reportResultsTable.addClass('sorting');
        $('body').css('cursor', 'progress');

        me.$reportResultsTable.bootstrapTable('destroy');
        me.$reportResultsTable.bootstrapTable(me.tableOptions);

        $('#report-toolbar').show();
    };

    me.exportReport = () => {
        const opts = $('#report-results-table').bootstrapTable('getOptions');
        const exportParams = me.getReportParams({
            columns: _.map($('#report-results-table').bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
            offset: 0,
            sort: opts.sortName,
            order: opts.sortOrder,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${me.exportUrl}?${queryString}`, '_blank');
    };

    me.initEvents = () => {
        // Ported from bootstrap-select to Tom Select 2026-05-12.
        // Same pattern as lessonsOverviewReport.js: destroy + recreate
        // (initEvents runs multiple times per tab re-render) plus
        // "click optgroup header to select all items in group" UX
        // rewired onto Tom Select's .optgroup-header / .optgroup DOM.
        const lessonsEl = document.getElementById('lessons');
        if (!lessonsEl) return;

        if (lessonsEl.tomselect) {
            lessonsEl.tomselect.destroy();
        }
        $(lessonsEl).val('');

        const tom = new TomSelect(lessonsEl, {
            placeholder: 'All Lessons',
            plugins: ['remove_button'],
            diacritics: true,
            maxOptions: null,
            onDropdownOpen() {
                const headers = this.dropdown_content.querySelectorAll(
                    '.optgroup-header:not([data-group-toggle])',
                );
                headers.forEach((header) => {
                    header.setAttribute('data-group-toggle', '1');
                    header.style.cursor = 'pointer';
                    header.addEventListener('click', () => {
                        const group = header.parentElement;
                        if (!group) return;
                        group.querySelectorAll('.option').forEach((opt) => {
                            const value = opt.getAttribute('data-value');
                            if (value) tom.addItem(value, true);
                        });
                    });
                });
            },
        });
    };

    me.getReportParams = (params) => {
        const searchParams = _.extend({}, params);
        searchParams.license_ids = $('#user-license-ids').val();
        searchParams.date = $('#search-date option:selected').val();
        searchParams.date_range_from = $('#search-start-date').val();
        searchParams.date_range_to = $('#search-end-date').val();
        searchParams.grade = $('#user-grades').val();
        searchParams.lessonIds = $('#lessons').val();
        searchParams.subtitle = $('#subtitle').val();

        return searchParams;
    };

    me.tableOptions = _.extend({}, Jr.reportsDataTable.options, {
        idField: 'lesson_id',
        url: me.reportUrl,
        toolbar: '#report-toolbar',
        queryParamsType: '',
        queryParams: (params) => me.getReportParams(params),

        formatNoMatches() {
            return 'No lessons to show';
        },

        onLoadSuccess(data) {
            $('time.timeago').timeago();
            me.$reportResultsTable.removeClass('sorting');
            me.$reportResultsTable.closest('.bootstrap-table').find('.pagination-detail .duration').remove();
            me.$reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(`<span class="duration">&nbsp;&nbsp;&nbsp;<em>(query took ${data.duration.toFixed(4)} seconds)</em></span>`);

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();
        },

        columns: [
            {
                title: 'Lesson Name',
                field: 'lesson_name',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: true,
            },
            {
                title: 'Grade(s)',
                field: 'grade_band',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: true,
            },
            {
                title: 'Subtitle',
                field: 'subtitle',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned To',
                field: 'assigned_to',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Interest Response',
                field: 'interest',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value) => value.charAt(0).toUpperCase() + value.slice(1),
            },
            {
                title: 'Assigned By',
                field: 'assigned_by',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Completed Date',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
        ],
    });

    return my;
})(Postlogin);
